import "./ModifyPassword.css"
import React, {useState} from "react";
import InputForm from "../../Components/InputForm/InputForm"
import Input from "../../Model/Input"
import { userAtom } from "../../RecoilApp";
import { useRecoilValue } from "recoil";
import Button from "../../Model/Button";
import { useUserActions } from "../../../Connect/_actions";
import swal from 'sweetalert';
import validator from 'validator';
import cryptString from "../../Useful/cryptString";
import Loc from "../../../Loc/Loc";

const  minPasswordLength : number = 8;

function isValidPassword(password: string) {
    if (validator.isStrongPassword(password, {minLength: minPasswordLength, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1})) {
        return true;
    }
    return false;
}

interface ModifyPasswordProps {
    buttons: Button[];
    firstConnection: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setPageOnClick? : (page: string) => void;
}

export default function ModifyPassword(props: ModifyPasswordProps) {
    const userActions = useUserActions();
    const [currentPasswordInput, setCurrentPasswordInput] = useState("");
    const [newPasswordInput, setNewPasswordInput] = useState("");
    const [confirmPasswordInput, setConfirmPasswordInput] = useState("");
    const [error, setError] = useState("");
    const user = useRecoilValue(userAtom);

    const HandleOnChangeCurrentPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setError("");
        setCurrentPasswordInput(event.target.value);
    }

    const HandleOnChangeNewPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setError("");
        setNewPasswordInput(event.target.value);
    }

    const HandleOnChangeConfirmPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setError("");
        setConfirmPasswordInput(event.target.value);
    }

    const sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    const inputCurrentPassword: Input = {HandleOnChange : HandleOnChangeCurrentPassword, title: Loc.trad().ModifyPasswordActual, type : "password", placeHolder : Loc.trad().ModifyPasswordActualText, className : "form-control"};
    const inputNewPassword: Input = {HandleOnChange : HandleOnChangeNewPassword, title : Loc.trad().ModifyPasswordNew, type : "password", placeHolder : Loc.trad().ModifyPasswordNewText, className : "form-control"};
    const inputConfirmPassword: Input = {HandleOnChange : HandleOnChangeConfirmPassword, title : Loc.trad().ModifyPasswordConfirm, type : "password", placeHolder : Loc.trad().ModifyPasswordConfirmText, className: "form-control"};

    const [inputs, setInputs] = useState([inputCurrentPassword, inputNewPassword, inputConfirmPassword]);

    const inputWrongCurrentPassword: Input = {HandleOnChange : HandleOnChangeCurrentPassword, title: Loc.trad().ModifyPasswordActual, type : "password", placeHolder : Loc.trad().ModifyPasswordActualText, className : "form-control wrongpassword"};
    const inputWrongNewPassword: Input = {HandleOnChange : HandleOnChangeNewPassword, title : Loc.trad().ModifyPasswordNew, type : "password", placeHolder : Loc.trad().ModifyPasswordNewText, className : "form-control wrongpassword"};
    const inputWrongConfirmPassword: Input = {HandleOnChange : HandleOnChangeConfirmPassword, title : Loc.trad().ModifyPasswordConfirm, type : "password", placeHolder : Loc.trad().ModifyPasswordConfirmText, className : "form-control wrongpassword"};

    const HandleErrorPassword = async (error: string) => {
        setError(error);
        props.setIsLoading(false);
        setInputs([inputWrongCurrentPassword, inputWrongNewPassword, inputWrongConfirmPassword]);
        await sleep(1500);
        setInputs([inputCurrentPassword, inputNewPassword, inputConfirmPassword]);
    }

    const HandleOnSubmit = async (e: any) => {
        e.preventDefault();
        if (newPasswordInput !== confirmPasswordInput) {
            HandleErrorPassword(Loc.trad().ModifyPasswordErrorDiff);
        }
        else if (!isValidPassword(newPasswordInput)) {
            HandleErrorPassword(Loc.trad().ModifyPasswordErrorInvalid+minPasswordLength+Loc.trad().ModifyPasswordErrorInvalid2);
        }
        else {
            props.setIsLoading(true);
            userActions.login(user.username, props.firstConnection ? currentPasswordInput : cryptString(currentPasswordInput))
            .then(() => {
                userActions.updatePassword(user.username, cryptString(newPasswordInput), user.id)
                .then(() => {
                    if (props.firstConnection) {
                        userActions.login(user.username, cryptString(newPasswordInput)).then(() => {
                            swal({ title: Loc.trad().ModifyPasswordSuccess, icon: "success" });
                            // setIsLoading(false);
                        })
                    }
                    else {
                        props.setPageOnClick!("Home");
                        swal({ title: Loc.trad().ModifyPasswordSuccess, icon: "success" });
                    }
                })
                .catch((error) => {
                    props.setIsLoading(false);
                    setError(error);
                });
            })
            .catch(() => {
                setError(Loc.trad().ModifyPasswordErrorIncorrect);
                props.setIsLoading(false);
            })
        }
    }

    return (
        <InputForm
        HandleOnSubmit={HandleOnSubmit}
        inputs={inputs}
        error={error}
        buttons={props.buttons}>
        </InputForm>
    )
}